<div style="background-color:white;">
    <app-carousel></app-carousel>

    <div [ngStyle]="{'margin': isXxxs ? '10px 10px 10px 10px' 
                               : isXxs ? '40px 40px 40px 40px'
                               : '60px 60px 60px 60px'}">
        <app-about-us></app-about-us>
    </div>

    <div id="mission"
        [ngStyle]="{'margin': isXxxs ? '0 10px 10px 10px' 
                                : isXxs ? '0 40px 40px 40px'
                                : '0 60px 60px 60px'}">
        <app-presentation></app-presentation>
    </div>

    <div id="services"
        [ngStyle]="{'margin': isXxxs ? '0 10px 60px 10px' 
                                : isXxs ? '0 40px 40px 40px'
                                : '0 60px 60px 60px'}">
        <app-services></app-services>
    </div>

    <div id="team"
        [ngStyle]="{'margin': isXxxs ? '0 10px 10px 10px' 
                                : isXxs ? '0 40px 40px 40px'
                                : '0 60px 60px 60px'}">
        <app-team></app-team>
    </div>

    <div id="form" *ngIf="!formSubmitted"
        [ngStyle]="{'margin': isXxxs ? '0 10px 10px 10px' 
                                : isXxs ? '0 40px 40px 40px'
                                : '0 60px 60px 60px'}">
        <app-home-form  (output)="manageSuccessfulSubmit()"></app-home-form>
    </div>

    <div class="content layout horizontal center top" style="margin-bottom: 20px">
        <div id="form" *ngIf="formSubmitted" class="content layout horizontal center top" [ngStyle]="{'color': Color.main}" style="border: 2px solid #e7bd42; border-radius: 15px; background-color: #212121;  width: 500px; font-weight: bold; font-size:18px; padding:20px; line-height: 1.2">
            Complimenti per aver richiesto la prenotazione di una lezione. Il nostro staff ti ricontatterà al più presto.
        </div>
    </div>
   
    
    <app-home-footer></app-home-footer>
</div>


